"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/* eslint-disable react/prop-types */


var DiscountPurchaseModel = function DiscountPurchaseModel(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  var visible = props.visible,
      onCancel = props.onCancel,
      onOk = props.onOk,
      onModelChange = props.onModelChange,
      data = props.data,
      modelText = props.modelText,
      selectProduce = props.selectProduce,
      colorTheme = props.colorTheme;
  var _o = data.modelTitle,
      modelTitle = _o === void 0 ? '轻应用服务器-配置选择' : _o,
      _p = data.title,
      title = _p === void 0 ? '' : _p,
      _q = data.regionInfoList,
      regionInfoList = _q === void 0 ? [] : _q,
      _r = data.bluePrintList,
      bluePrintList = _r === void 0 ? [] : _r,
      _s = data.timeInfoList,
      timeInfoList = _s === void 0 ? [] : _s,
      _t = data.limitNum,
      limitNum = _t === void 0 ? 0 : _t,
      _u = data.minPurchaseNum,
      minPurchaseNum = _u === void 0 ? 1 : _u,
      _v = data.platformType,
      platformType = _v === void 0 ? '' : _v,
      _w = data.skuList,
      skuList = _w === void 0 ? {} : _w,
      _x = data.eventId,
      eventId = _x === void 0 ? '' : _x,
      _y = data.ecId,
      ecId = _y === void 0 ? '' : _y,
      _z = data.cardDiscount,
      cardDiscount = _z === void 0 ? '' : _z,
      _0 = data.cardOriginal,
      cardOriginal = _0 === void 0 ? '' : _0,
      _1 = data.extendModelBtnProps,
      extendModelBtnProps = _1 === void 0 ? '' : _1;

  var _2 = (0, _react.useState)(false),
      isShow = _2[0],
      setShow = _2[1];

  var orderInfo = {
    eventId: '',
    ecId: '',
    orderInfo: {
      price: 0,
      skuId: '',
      regionId: '',
      bluePrintId: '',
      timeUnit: '',
      timeSpan: '',
      purchaseNum: 1
    }
  };

  var _3 = (0, _react.useState)(0),
      timeInfoListIndex = _3[0],
      setTimeInfoListIndex = _3[1];

  var _4 = (0, _react.useState)(0),
      regionInfoListIndex = _4[0],
      setRegionInfoListIndex = _4[1];

  var _5 = (0, _react.useState)(0),
      bluePrintListIndex = _5[0],
      setBluePrintListIndex = _5[1];

  var _6 = (0, _react.useState)(true),
      isQueryPrice = _6[0],
      setQueryPrice = _6[1]; // 弹出框默认显示询价，当获取到数据，或是切换条件进行询价时成功是设为false


  var _7 = (0, _react.useState)(false),
      isBuyWait = _7[0],
      setBuyWait = _7[1]; // 弹出框购买按钮是否需要等待


  var _8 = (0, _react.useState)(bluePrintList),
      imageList = _8[0],
      setImageList = _8[1]; // 镜像信息需要动态变化


  var _9 = (0, _react.useState)(100),
      modelHeight = _9[0],
      setModelHeight = _9[1];

  var _10 = (0, _react.useState)(cardDiscount),
      discount = _10[0],
      setDiscount = _10[1];

  var _11 = (0, _react.useState)(cardOriginal),
      original = _11[0],
      setOriginal = _11[1];

  var _12 = (0, _react.useState)(minPurchaseNum),
      purchaseNum = _12[0],
      setPurchaseNum = _12[1];

  var _13 = (0, _react.useState)('询价中...'),
      priceText = _13[0],
      setPriceText = _13[1];

  var dropDownAreaButton = (0, _react.useRef)(null);
  var dropDownOsButton = (0, _react.useRef)(null);

  var handleAdd = function handleAdd() {
    var nextBuyNem = purchaseNum + 1;

    if (nextBuyNem <= limitNum) {
      var skuId = 'sku';
      var _a = (regionInfoList[regionInfoListIndex] || {}).regionId,
          regionId = _a === void 0 ? 0 : _a;
      var _b = (imageList[bluePrintListIndex] || {}).blueprintId,
          blueprintId = _b === void 0 ? '' : _b;

      var _c = timeInfoList[timeInfoListIndex] || {},
          _d = _c.timeUnit,
          timeUnit = _d === void 0 ? 0 : _d,
          _e = _c.timeSpan,
          timeSpan = _e === void 0 ? 0 : _e;

      skuId = skuId + "_" + regionId + "_" + timeUnit + "_" + timeSpan;
      var selectSkuIndex = skuList[skuId];
      onModelChange({
        skuId: selectSkuIndex,
        regionId: regionId,
        bluePrintId: blueprintId,
        timeUnit: timeUnit,
        timeSpan: timeSpan,
        purchaseNum: nextBuyNem,
        eventId: eventId,
        ecId: ecId,
        platformType: platformType
      }, 'num');
      setBuyWait(true); // 点击数量，按钮都是不可点击

      setPurchaseNum(nextBuyNem);
    }
  };

  var handleReduce = function handleReduce() {
    var buyNextNum = purchaseNum - 1;

    if (buyNextNum >= minPurchaseNum) {
      var skuId = 'sku';
      var _a = (regionInfoList[regionInfoListIndex] || {}).regionId,
          regionId = _a === void 0 ? 0 : _a;
      var _b = (imageList[bluePrintListIndex] || {}).blueprintId,
          blueprintId = _b === void 0 ? '' : _b;

      var _c = timeInfoList[timeInfoListIndex] || {},
          _d = _c.timeUnit,
          timeUnit = _d === void 0 ? 0 : _d,
          _e = _c.timeSpan,
          timeSpan = _e === void 0 ? 0 : _e;

      skuId = skuId + "_" + regionId + "_" + timeUnit + "_" + timeSpan;
      var selectSkuIndex = skuList[skuId];
      onModelChange({
        skuId: selectSkuIndex,
        regionId: regionId,
        bluePrintId: blueprintId,
        timeUnit: timeUnit,
        timeSpan: timeSpan,
        purchaseNum: buyNextNum,
        eventId: eventId,
        ecId: ecId,
        platformType: platformType
      }, 'num');
      setBuyWait(true); // 点击数量，按钮都是不可点击

      setPurchaseNum(buyNextNum);
    }
  };

  var setPrice = function setPrice(index, type, e) {
    e.stopPropagation(); // 阻止冒泡

    var skuId = 'sku';
    var isUpdatePrice = false;
    var _a = (regionInfoList[regionInfoListIndex] || {}).regionId,
        regionId = _a === void 0 ? 0 : _a;
    var _b = (imageList[bluePrintListIndex] || {}).blueprintId,
        blueprintId = _b === void 0 ? '' : _b;

    var _c = timeInfoList[timeInfoListIndex] || {},
        _d = _c.timeUnit,
        timeUnit = _d === void 0 ? 0 : _d,
        _e = _c.timeSpan,
        timeSpan = _e === void 0 ? 0 : _e; // 根据不同 type 设置不同的参数


    if (type === 'area') {
      if (index !== regionInfoListIndex) {
        setBuyWait(true); // 切换镜像，切换价格，按钮都是不可点击

        isUpdatePrice = true; // 选择不同区域时才需要更新数据，否不更新

        setRegionInfoListIndex(index);
        regionId = regionInfoList[index].regionId;
      }
    } else if (type === 'image') {
      if (index !== bluePrintListIndex) {
        setBuyWait(true); // 切换镜像，切换价格，按钮都是不可点击

        isUpdatePrice = true; // 选择不同镜像时才需要更新数据，否不更新

        setBluePrintListIndex(index);
        blueprintId = imageList[index].blueprintId;
      }
    } else if (type === 'time') {
      if (index !== timeInfoListIndex) {
        setBuyWait(true); // 切换镜像，切换价格，按钮都是不可点击

        isUpdatePrice = true; // 选择不同时间时才需要更新数据，否不更新

        setTimeInfoListIndex(index);
        timeUnit = timeInfoList[index].timeUnit;
        timeSpan = timeInfoList[index].timeSpan;
      }
    } // 如果是区域或者镜像则隐藏下拉框


    if (['area', 'image'].includes(type)) {
      var parentElem = e.currentTarget.parentElement.parentElement;

      if (type === 'image') {
        parentElem = parentElem.parentElement;
      }

      var parentElemClass = parentElem.classList;

      if (parentElemClass.contains('active')) {
        parentElem.classList.remove('active');
      } else {
        parentElem.classList.add('active');
      }
    }

    skuId = skuId + "_" + regionId + "_" + timeUnit + "_" + timeSpan;
    var selectSkuIndex = skuList[skuId]; // 如果是区域切换，需要再触发一个镜像更新的接口，再去获取价格，所以传参上为区域时少传个地区，分开写是为了以后如果还有别的联动信息，直接继续添加

    if (isUpdatePrice) {
      if (type === 'area') {
        onModelChange({
          skuId: selectSkuIndex,
          regionId: regionId,
          timeUnit: timeUnit,
          timeSpan: timeSpan,
          purchaseNum: purchaseNum,
          eventId: eventId,
          ecId: ecId,
          platformType: platformType
        }, type);
      } else {
        onModelChange({
          skuId: selectSkuIndex,
          regionId: regionId,
          bluePrintId: blueprintId,
          timeUnit: timeUnit,
          timeSpan: timeSpan,
          purchaseNum: purchaseNum,
          eventId: eventId,
          ecId: ecId,
          platformType: platformType
        }, type);
      }
    }
  };

  var toggleActive = function toggleActive(e) {
    var target = e.currentTarget;
    var targetClassList = target.classList;

    if (targetClassList.contains('active')) {
      target.classList.remove('active');
    } else {
      target.classList.add('active');
    }
  };

  var handleAreaMouseLeave = function handleAreaMouseLeave(type) {
    var target = null;
    var targetClassList = null;

    if (type === 'image') {
      target = dropDownOsButton.current;
      targetClassList = dropDownOsButton.current.classList;
    } else if (type === 'area') {
      target = dropDownAreaButton.current;
      targetClassList = dropDownAreaButton.current.classList;
    }

    if (targetClassList.contains('active')) {
      target.classList.remove('active');
    }
  };

  var handleBuyButton = function handleBuyButton() {
    var _a, _b, _c, _d; // 询价或者购买中，按钮都不可再点击


    if (!isBuyWait) {
      if (!isQueryPrice) {
        var skuIndex = 'sku';
        var regionId = ((_a = regionInfoList[regionInfoListIndex]) === null || _a === void 0 ? void 0 : _a.regionId) || '';
        var timeUnit = ((_b = timeInfoList[timeInfoListIndex]) === null || _b === void 0 ? void 0 : _b.timeUnit) || '';
        var timeSpan = ((_c = timeInfoList[timeInfoListIndex]) === null || _c === void 0 ? void 0 : _c.timeSpan) || '';
        var blueprintId = ((_d = imageList[bluePrintListIndex]) === null || _d === void 0 ? void 0 : _d.blueprintId) || '';
        orderInfo.eventId = eventId;
        orderInfo.ecId = ecId;
        skuIndex = skuIndex + "_" + regionId + "_" + timeUnit + "_" + timeSpan;
        var skuId = skuList[skuIndex];
        orderInfo.orderInfo = {
          price: discount,
          purchaseNum: purchaseNum,
          bluePrintId: blueprintId,
          regionId: regionId,
          timeUnit: timeUnit,
          timeSpan: timeSpan,
          skuId: skuId
        };
        setBuyWait(true); // 点击购买后，把按钮变成不可点击

        onOk(orderInfo);
      }
    }
  };

  (0, _react.useEffect)(function () {
    if (Object.keys(selectProduce).length) {
      var areaIndex = regionInfoList.findIndex(function (item) {
        return item.regionId === selectProduce.regionId;
      });
      var imageIndex = imageList.findIndex(function (item) {
        return item.blueprintId === selectProduce.blueprintId;
      });
      var timeIndex = timeInfoList.findIndex(function (item) {
        return item.timeUnit === selectProduce.timeUnit && item.timeSpan === selectProduce.timeSpan;
      });
      setRegionInfoListIndex(areaIndex);
      setBluePrintListIndex(imageIndex);
      setTimeInfoListIndex(timeIndex);
      setPurchaseNum(minPurchaseNum); // 弹出框信息切换后，重制购买数量为最小购买数量
    }
  }, [selectProduce]);
  (0, _react.useEffect)(function () {
    setDiscount(modelText.discount);
    setOriginal(modelText.original);

    if (modelText.bluePrintList) {
      setImageList(modelText.bluePrintList);
      var imageIndex = 0;

      if (modelText.blueprintId) {
        // 如果有传 blueprintId，则根据这个判断，显示第几个镜像，没有默认展示第一个(默认值)
        imageIndex = modelText.bluePrintList.findIndex(function (item) {
          return item.blueprintId === modelText.blueprintId;
        });
      }

      setBluePrintListIndex(imageIndex);
    }

    if (modelText.isQueryPrice !== undefined) {
      setQueryPrice(modelText.isQueryPrice);
    }

    if (modelText.isBuyWait !== undefined) {
      setBuyWait(modelText.isBuyWait);
    }

    if (modelText.queryPriceText) {
      setPriceText(modelText.queryPriceText);
    }
  }, [modelText]);
  (0, _react.useEffect)(function () {
    setShow(visible);

    if (Object.keys(selectProduce).length) {
      var areaIndex = regionInfoList.findIndex(function (item) {
        return item.regionId === selectProduce.regionId;
      });
      var imageIndex = imageList.findIndex(function (item) {
        return item.blueprintId === selectProduce.blueprintId;
      });
      var timeIndex = timeInfoList.findIndex(function (item) {
        return item.timeUnit === selectProduce.timeUnit && item.timeSpan === selectProduce.timeSpan;
      });
      setRegionInfoListIndex(areaIndex);
      setBluePrintListIndex(imageIndex);
      setTimeInfoListIndex(timeIndex);
      setPurchaseNum(selectProduce.purchaseNum || 1);
    }

    if (data.bluePrintList) {
      // 弹出框展开的时候，更新下镜像数据，因为镜像数据做成了响应式，相关值需要做出动态设置
      var imageIndex = data.bluePrintList.findIndex(function (item) {
        return item.blueprintId === selectProduce.blueprintId;
      });
      setImageList(data.bluePrintList);
      setBluePrintListIndex(imageIndex);
    }

    if (window.screen.height > 660) {
      // 660 是移动端弹出框，可以展示的最大高度
      setModelHeight(window.screen.height - 660);
    }
  }, [visible]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model " + (isShow ? 'model-show' : 'model-hidden')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mask"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile",
    style: {
      height: "calc(100% - " + modelHeight + "px)",
      width: '100%',
      top: modelHeight + "px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__title"
  }, modelTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__close",
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6114 11.9743L5.29285 17.2928L6.70706 18.7071L12.0256 13.3885L17.3399 18.7028L18.7028 17.3399L13.3885 12.0256L18.7071 6.70706L17.2928 5.29285L11.9743 10.6114L6.65581 5.29285L5.29285 6.65581L10.6114 11.9743Z",
    fill: "black"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__selected"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__selected__tip"
  }, modelText.selectedText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__selected__info"
  }, /*#__PURE__*/_react["default"].createElement("span", null, modelText.podText), /*#__PURE__*/_react["default"].createElement("span", null, title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__area"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__area__tip"
  }, modelText.areaText), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__mobile__wrap__area__button', {
      'mo-area-button-studentActivities-theme': colorTheme == 'studentActivities'
    }),
    onClick: function onClick(e) {
      return toggleActive(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("p", null, (_a = regionInfoList[regionInfoListIndex]) === null || _a === void 0 ? void 0 : _a.regionName), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__area__button__menuregion"
  }, regionInfoList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setPrice(index, 'area', e);
      },
      key: index
    }, item.regionName);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__area"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__area__tip"
  }, modelText.osName), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__mobile__wrap__area__button', {
      'mo-area-button-studentActivities-theme': colorTheme == 'studentActivities'
    }),
    onClick: function onClick(e) {
      return toggleActive(e);
    }
  }, ((_b = imageList[bluePrintListIndex]) === null || _b === void 0 ? void 0 : _b.imageUrl) && /*#__PURE__*/_react["default"].createElement("img", {
    className: "flex-discount-purchase-model__mobile__wrap__area__button__icon",
    src: ((_c = imageList[bluePrintListIndex]) === null || _c === void 0 ? void 0 : _c.imageUrl) || '',
    alt: ((_d = imageList[bluePrintListIndex]) === null || _d === void 0 ? void 0 : _d.displayTitle) || ''
  }), /*#__PURE__*/_react["default"].createElement("p", null, (((_e = imageList[bluePrintListIndex]) === null || _e === void 0 ? void 0 : _e.displayTitle) || '') + " " + (((_f = imageList[bluePrintListIndex]) === null || _f === void 0 ? void 0 : _f.displayVersion) || '')), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__area__button__menu"
  }, imageList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: "flex-discount-purchase-model__mobile__wrap__area__button__menu__box"
    }, (item === null || item === void 0 ? void 0 : item.imageUrl) && /*#__PURE__*/_react["default"].createElement("img", {
      className: "flex-discount-purchase-model__mobile__wrap__area__button__menu__box__icon",
      src: item.imageUrl,
      alt: item.osName || ''
    }), /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setPrice(index, 'image', e);
      },
      key: index
    }, ((item === null || item === void 0 ? void 0 : item.displayTitle) || '') + " " + ((item === null || item === void 0 ? void 0 : item.displayVersion) || '')));
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__time"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__time__tip"
  }, modelText.timeText), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__mobile__wrap__time__list', {
      'list-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, timeInfoList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: index === timeInfoListIndex ? 'active' : '',
      onClick: function onClick(e) {
        return setPrice(index, 'time', e);
      },
      key: index
    }, item.timeText);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__num"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__num__tip"
  }, modelText.numText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__num__oprate"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__num__oprate__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleReduce
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3223 7.69904H10.208H1.35303V10.229H10.208H10.3223H16.5329V7.69904H10.3223Z",
    fill: "black",
    fillOpacity: "0.24",
    style: purchaseNum <= minPurchaseNum ? {
      fillOpacity: 0.08
    } : {}
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "num"
  }, purchaseNum), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.208 7.69905V1.37411H7.67797V7.69905H1.35303V10.229H7.67797V16.554H10.208V10.229H16.5329V7.69905H10.208Z",
    fill: "black",
    fillOpacity: "0.24",
    style: purchaseNum >= limitNum ? {
      fillOpacity: 0.08
    } : {}
  })))), limitNum < 999999 ? /*#__PURE__*/_react["default"].createElement("p", null, modelText.limitText, limitNum, modelText.unitText) : /*#__PURE__*/_react["default"].createElement("p", null, modelText.infinityText))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__mobile__wrap__price', {
      'mo-price-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__mobile__wrap__price__tip"
  }, modelText.totalText), isQueryPrice ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__price-check"
  }, priceText) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__price-discount"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), discount), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__mobile__wrap__price-original"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), original)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__mobile__wrap__button', {
      'mo-btn-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    onClick: onCancel
  }, modelText.cancelText), /*#__PURE__*/_react["default"].createElement("p", {
    className: isQueryPrice || isBuyWait ? 'flex-discount-purchase-model__mobile__wrap__button__p-disable' : '',
    onClick: function onClick() {
      return handleBuyButton();
    }
  }, modelText.buttonText)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__title"
  }, modelTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__close",
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6114 11.9743L5.29285 17.2928L6.70706 18.7071L12.0256 13.3885L17.3399 18.7028L18.7028 17.3399L13.3885 12.0256L18.7071 6.70706L17.2928 5.29285L11.9743 10.6114L6.65581 5.29285L5.29285 6.65581L10.6114 11.9743Z",
    fill: "black"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__selected"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__selected__tip"
  }, modelText.selectedText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__selected__info"
  }, /*#__PURE__*/_react["default"].createElement("span", null, modelText.podText), /*#__PURE__*/_react["default"].createElement("span", null, title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__area",
    onMouseLeave: function onMouseLeave() {
      return handleAreaMouseLeave('area');
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__area__tip"
  }, modelText.areaText), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__wrap__model__area__button', {
      'model-area-button-studentActivities-theme': colorTheme == 'studentActivities'
    }),
    onClick: function onClick(e) {
      return toggleActive(e);
    },
    ref: dropDownAreaButton
  }, /*#__PURE__*/_react["default"].createElement("p", null, (_g = regionInfoList[regionInfoListIndex]) === null || _g === void 0 ? void 0 : _g.regionName), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__area__button__menuregion"
  }, regionInfoList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setPrice(index, 'area', e);
      },
      key: index
    }, item.regionName);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__area",
    onMouseLeave: function onMouseLeave() {
      return handleAreaMouseLeave('image');
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__area__tip"
  }, modelText.osName), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__wrap__model__area__button', {
      'model-area-button-studentActivities-theme': colorTheme == 'studentActivities'
    }),
    onClick: function onClick(e) {
      return toggleActive(e);
    },
    ref: dropDownOsButton
  }, ((_h = imageList[bluePrintListIndex]) === null || _h === void 0 ? void 0 : _h.imageUrl) && /*#__PURE__*/_react["default"].createElement("img", {
    className: "flex-discount-purchase-model__wrap__model__area__button__icon",
    src: ((_j = imageList[bluePrintListIndex]) === null || _j === void 0 ? void 0 : _j.imageUrl) || '',
    alt: ((_k = imageList[bluePrintListIndex]) === null || _k === void 0 ? void 0 : _k.osName) || ''
  }), /*#__PURE__*/_react["default"].createElement("p", null, (((_l = imageList[bluePrintListIndex]) === null || _l === void 0 ? void 0 : _l.displayTitle) || '') + " " + (((_m = imageList[bluePrintListIndex]) === null || _m === void 0 ? void 0 : _m.displayVersion) || '')), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__area__button__menu"
  }, imageList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: "flex-discount-purchase-model__wrap__model__area__button__menu__box"
    }, (item === null || item === void 0 ? void 0 : item.imageUrl) && /*#__PURE__*/_react["default"].createElement("img", {
      className: "flex-discount-purchase-model__wrap__model__area__button__menu__box__icon",
      src: item.imageUrl,
      alt: item.osName || ''
    }), /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setPrice(index, 'image', e);
      },
      key: index
    }, ((item === null || item === void 0 ? void 0 : item.displayTitle) || '') + " " + ((item === null || item === void 0 ? void 0 : item.displayVersion) || '')));
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__time"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__time__tip"
  }, modelText.timeText), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__wrap__model__time__list', {
      'list-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, timeInfoList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: index === timeInfoListIndex ? 'active' : '',
      onClick: function onClick(e) {
        return setPrice(index, 'time', e);
      },
      key: index
    }, item.timeText);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__num"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__num__tip"
  }, modelText.numText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__num__oprate"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__num__oprate__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleReduce
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3223 7.69904H10.208H1.35303V10.229H10.208H10.3223H16.5329V7.69904H10.3223Z",
    fill: "black",
    fillOpacity: "0.24",
    style: purchaseNum <= minPurchaseNum ? {
      fillOpacity: 0.08
    } : {}
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "num"
  }, purchaseNum), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.208 7.69905V1.37411H7.67797V7.69905H1.35303V10.229H7.67797V16.554H10.208V10.229H16.5329V7.69905H10.208Z",
    fill: "black",
    fillOpacity: "0.24",
    style: purchaseNum >= limitNum ? {
      fillOpacity: 0.08
    } : {}
  })))), limitNum < 999999 ? /*#__PURE__*/_react["default"].createElement("p", null, modelText.limitText, limitNum, modelText.unitText) : /*#__PURE__*/_react["default"].createElement("p", null, modelText.infinityText))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__price"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-model__wrap__model__price__tip"
  }, modelText.totalText), isQueryPrice ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__wrap__model__price-check', {
      'model-price-discount-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, priceText) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-model__wrap__model__price-discount', {
      'model-price-discount-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), discount), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-model__wrap__model__price-original"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), original))), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])(isQueryPrice || isBuyWait ? 'flex-discount-purchase-model__wrap__model__button-disable' : 'flex-discount-purchase-model__wrap__model__button', {
      'model-button-studentActivities-theme': colorTheme == 'studentActivities'
    })
  }, extendModelBtnProps || {}, {
    onClick: function onClick() {
      return handleBuyButton();
    }
  }), modelText.buttonText))));
};

DiscountPurchaseModel.displayName = 'TCIDiscountPurchaseModel';
var _default = DiscountPurchaseModel;
exports["default"] = _default;